import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { ZariContext } from '_zari/context'
import { Portlet, Alert } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as PreFacturacionService from 'services/preFacturacion.service'

import MainForm from './mainForm'

const NuevoActualizarPage = ({ match }) => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    let baseName = 'Pre-Ventas'

    if (match.params.id) {
      return [{ name: baseName, path: `/${CodigosTransaccionesConstant.PREFACTURACIONES_LISTA}` }, { name: 'Editar' }]
    }

    return [{ name: baseName, path: `/${CodigosTransaccionesConstant.PREFACTURACIONES_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      PreFacturacionService.obtenerxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [__zariContext, match.params.id])

  return (
    <>
      {__adminContext.estadoTurno ? (
        <Portlet>
          <Portlet.Header title='Pre-Ventas' breadcrumbs={portletBreadcrumbs} />
          <Portlet.Body>
            {__keyMainForm && (
              <MainForm
                key={__keyMainForm}
                editarData={editarDataRef.current}
                flagEditar={!!editarDataRef.current._id}
                reiniciarFormulario={() => setKeyMainForm(IdGen.newId())}
              />
            )}
          </Portlet.Body>
        </Portlet>
      ) : (
        <Alert color='danger'>Esta función requiere aperturar turno.</Alert>
      )}
    </>
  )
}

export default NuevoActualizarPage
